import { Component, computed, inject, signal, Signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Tool } from '../../../utils/models/tool.models';
import { RegistrationListComponent } from '../registration-list/registration-list.component';
import { MatButton } from '@angular/material/button';
import { ToolService } from '../../../services/api-services/tools/tool.service';
import { UserService } from '../../../services/api-services/user.service';

@Component({
  selector: 'app-tool-registration-dialog',
  templateUrl: './tool-registration-dialog.component.html',
  styleUrls: ['./tool-registration-dialog.component.scss'],
  imports: [RegistrationListComponent, MatButton],
})
export class ToolRegistrationDialogComponent {
  /** Inject services. */
  private readonly dialogRef = inject<MatDialogRef<ToolRegistrationDialogComponent>>(MatDialogRef);
  private readonly toolService = inject(ToolService);
  private readonly userService = inject(UserService);
  private readonly tool = inject<Signal<Tool>>(MAT_DIALOG_DATA);

  /** Request resources. */
  readonly registrations = this.toolService.getRegistrations();
  readonly users = this.userService.getAllUsers();

  toolRegistration = computed(() => {
    const filteredRegistrations =
      this.registrations
        .value()
        ?.filter(registration => registration.tool.toolId == this.tool().toolId) ?? [];
    const selectedUsers = [];
    for (const registration of filteredRegistrations) {
      selectedUsers.push(registration.user);
    }
    return { tool: this.tool(), users: selectedUsers };
  });

  isLoading = signal(false);

  selectedItems: number[] = [];

  cancel() {
    this.dialogRef.close();
  }

  updateItems(ids: number[]) {
    this.selectedItems = ids;
  }

  async apply() {
    this.isLoading.set(true);
    const userIds = this.selectedItems;
    const promises: Promise<string>[] = [];
    for (const userId of userIds) {
      if (!this.toolRegistration().users.some(el => el.userId === userId)) {
        promises.push(
          this.toolService.updateRegistration(userId, this.toolRegistration().tool.toolId)
        );
      }
    }

    for (const user of this.users.value() ?? []) {
      if (
        !userIds.some(el => el === user.userId) &&
        this.toolRegistration().users.some(el => el.userId === user.userId)
      ) {
        promises.push(
          this.toolService.deleteRegistration(user.userId, this.toolRegistration().tool.toolId)
        );
      }
    }

    await Promise.all(promises);
    this.dialogRef.close();
  }
}
